import { Box } from "@mui/material";

type ImageSizingContainerProps = {
  source: any;
  alt: string;
  sx?: any;
};

const ImageSizingContainer = ({
  source,
  alt,
  sx,
}: ImageSizingContainerProps) => {
  return (
    <Box sx={sx}>
      <img
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
          borderRadius: "inherit",
        }}
        src={source}
        alt={alt}
      />
    </Box>
  );
};

export default ImageSizingContainer;

// export const PropertyImage = styled("img")`
//   width: 14em;
//   height: 8em;
//   object-fit: cover;
//   border-radius: 16px;
//   max-height: 8em;
// `;
